export const auth = {
  base: '/auth',
  login: 'login',
  logout: 'logout',
  emailVerification: 'email-verification',
  sso: 'sso',
  netsapiensCallback: 'netsapiens-callback'
};

export const base = (locationId: number | string = ':locationId') => `/location/${locationId}`;

export const agentBase = (locationId: number | string = ':locationId', agentId: number | string = ':agentId') =>
  `/location/${locationId}/agent/${agentId}`;

export const worksheetBase = (locationId: number | string = ':locationId', agentId: number | string = ':agentId') =>
  `/location/${locationId}/agent/${agentId}/worksheets`;

export const onBoarding = {
  create: 'create-agent',
  selectAgent: 'select-agent'
};

export const home = {
  performance: 'performance',
  callLogs: 'call-logs',
  chatLogs: 'chat-logs',
  signals: 'signals',
  configure: 'configure',
  worksheets: ':worksheetId?',
  profile: 'profile'
};

export const configure = {
  identity: 'identity',
  knowledge: 'knowledge',
  chunks: (datasetId: number | string = ':datasetId') => `${datasetId}`,
  behavior: 'behavior',
  deployPhone: 'deploy-phone',
  deployWeb: 'deploy-web',
  connectSms: 'connect-sms',
  personalizeLink: 'personalized-link'
};

export const behavior = {
  instructions: 'instructions'
};

export const business = {
  base: '/setting',
  profile: 'profile',
  billing: 'billing',
  team: 'team',
  addTeam: 'team/add',
  editTeam: (teamId = ':teamId') => `team/${teamId}`,
  locations: 'locations',
  addLocation: 'locations/add',
  editLocation: (locationId = ':locationId') => `locations/${locationId}`,
  usage: 'usage',
  auditTrails: 'audit-trails',
  contacts: 'contacts',
  KnowledgeBases: 'knowledge-bases',
  KnowledgeBase: 'knowledge-bases/:knowledgeBaseId',
  integration: 'integration',
  configureIntegration: (integrationId = ':integrationId') => `integration/${integrationId}`,
  workflows: 'workflows',
  apiKeys: 'api-keys',
  phoneNumbers: 'phone-numbers',
  phoneNumbersTab: (tab = ':tab') => `phone-numbers/${tab}`,
  telephony: 'telephony',
  telephonyTab: (tab = ':tab') => `telephony/${tab}`,
  addons: 'addons'
};

export const knowledgeBase = {
  dataset: 'dataset',
  retrievalTesting: 'retrieval-testing',
  chunks: (datasetId: number | string = ':datasetId') => `${datasetId}`
};

export const agency = {
  base: '/agency',
  businessProfileEdit: (id = ':businessId') => `businesses/${id}`,
  onboardingForms: 'onboarding-forms',
  onboardingFormEdit: (id = ':onboardingFormId') => `onboarding-forms/${id}`,
  onboardingFormHistory: (id = ':onboardingFormId') => `onboarding-forms/history/${id}`,
  billing: 'billing',
  businesses: '/agency',
  intraofficeNotes: 'intraoffice-notes',
  revenue: 'revenue',
  systemSentiment: 'system-sentiment',
  auditTrails: 'audit-trails',
  callLogs: 'call-logs',
  chatLogs: 'chat-logs',
  syncLogs: 'sync-logs',
  smsLogs: 'sms-logs',
  recommendations: 'recommendations',
  configuration: 'configuration',
  telephony: 'telephony',
  team: 'team',
  voiceEngines: 'voice-engines',
  integrations: 'integrations',
  coupons: 'coupons',
  developers: 'developers',
  integration: 'integrations/:integrationId',
  configureIntegration: 'configure',
  profile: 'profile'
};

export const developers = {
  apiKeys: 'api-keys',
  webhooks: 'webhooks'
};

export const configuration = {
  smtp: 'smtp',
  pricing: 'pricing',
  branding: 'branding',
  thirdParty: 'third-party'
};

export const telephony = {
  provider: (provider: string = ':provider') => provider,
  tab: (tab: string = ':tab') => tab
};

export const publicRoutes = {
  embedPreview: '/embed/talk/preview',
  previewLink: (location: string = ':location', agent: string = ':agent') => `/assistant/${location}/${agent}`
};

export const businessOnboarding = {
  base: '/business-onboarding',
  login: 'login',
  stage1: () => 'stage-1',
  stage2: () => 'stage-2',
  submitted: 'submitted'
};
